import { useEffect } from "react";
import { SlideUpModal } from "src/components/SlideUpModal";
import { useWebClientApi } from "src/api";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";

type ReopenApplicationModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
  confirmHandler: () => void;
};

const subText = `This application has already been submitted.
Any changes will require you to sign again.
`;

export default ({
  isOpen,
  closeHandler,
  confirmHandler,
}: ReopenApplicationModalProps) => {
  const api = useWebClientApi();
  const [submitHandler, loading, response] = useDlaFormSubmit(() =>
    api.reopenApplication(),
  );

  useEffect(() => {
    if (response) {
      confirmHandler();
    }
  }, [response]);

  return (
    <SlideUpModal
      title="Are you sure you want to edit?"
      subText={subText}
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Continue"
      actionButtonClickHandler={() => void submitHandler({})}
      isLoading={loading}
    />
  );
};
